import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import GenericPromises from '../../../../api/GenericPromises';
import { FormsErrors } from '../../../../hooks/Forms/FormsErrors';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { TextField } from '@mui/material';
import { PrimaryButton } from '../../../../theme/buttons';
import { CancellationReason } from '../../../../interfaces/Sales/Invoices/Cancellations/cancellationReason';
import useSnackBar from '../../../../components/Commons/SnackBar/useSnackBar';

export const UpdateCancellationReasons = ({ ...props }) => {
  const [t] = useTranslation("global");
  const { GenericPutResource, GenericGet } = GenericPromises();
  const { GetError } = FormsErrors();
  const [loadingPost, setLoadingPost] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const { cancellationReasonsPayload } = props;
  const { showSnackBar, SnackbarComponent } = useSnackBar();
  const isEdit = !props.isEdit;

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm<CancellationReason>({
    defaultValues: {
        cancellation_reason_key: '',
        description: ''
    }
  });
  const onSubmit: SubmitHandler<CancellationReason> = (data) => onPut(data);

  const onPut = (data: CancellationReason) => {
    let myData = {
        cancellation_reason_key: data.cancellation_reason_key,
        description: data.description ?? null
    }
    setLoadingPost(true);
    GenericPutResource(`/cancellationreasons/${cancellationReasonsPayload.cancellation_reason_id}`, myData)
      .then((response) => {
        showSnackBar(t("generic.snackbar.update"),"success");
        setLoadingPost(false);
      })
      .catch((error) => {
        setLoadingPost(false);
        showSnackBar(error.message,"error");
        setLoadingPost(false);
      });
  }

  useEffect(() => {
    reset({
      cancellation_reason_key: cancellationReasonsPayload.cancellation_reason_key,
      description: cancellationReasonsPayload.description ?? undefined
    });
    setDataLoaded(true);
  }, []);

  return (
    <>
      {dataLoaded &&
        <div className='d-flex justify-content-center'>
          <div className='custom-card-view w-75'>

            <form onSubmit={handleSubmit(onSubmit)} className='mt-4'>

              <div className="custom-card-row d-flex justify-content-between">

                <div className="w-100">
                  <div className='d-flex w-100'>
                    <div className='w-50'>
                      <Controller
                        name="cancellation_reason_key"
                        control={control}
                        rules={{ required: true, maxLength: 30 }}
                        render={({ field }) =>
                          <TextField
                            variant="filled"
                            label={`${t("cancellationreasons.fields.cancellation_reason_key")}`}
                            ref={field.ref}
                            value={field.value}
                            onChange={(event) => { field.onChange(event.target.value) }}
                            error={!!errors.cancellation_reason_key}
                            helperText={GetError(errors.cancellation_reason_key?.type)}
                            size="small"
                            style={{ width: "100%" }}
                            sx={{ paddingRight: 2 }}
                            disabled={isEdit}
                          />
                        }
                      />
                    </div>

                    <div className="w-50">
                      <Controller
                        name="description"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) =>
                          <TextField
                            ref={field.ref}
                            variant="filled"
                            value={field.value}
                            onChange={field.onChange}
                            label={t("cancellationreasons.fields.description")}
                            error={!!errors.description}
                            helperText={GetError(errors.description?.type)}
                            size="small"
                            style={{ width: "100%" }}
                            disabled={isEdit}
                          />
                        }
                      />
                    </div>
                  </div>
                </div>

              </div>

              {!isEdit &&
                <div className='d-flex flex-row-reverse mt-4'>
                  <PrimaryButton type='submit' variant='outlined' className='m-1' disabled={loadingPost}>{t("generic.buttons.update")}</PrimaryButton>
                </div>
              }

            </form>

          </div>
        </div>
      }
      <SnackbarComponent/>
    </>
  )
}
